import React from 'react';
import { useThemeContext } from '../../contexts';

type IconProps = {
  iconWidth?: number;
  iconHeight?: number;
};

/**
 * WalletIcon is a component that displays a wallet icon.
 *
 * @param {IconProps} props
 * @return {React.FC}
 */
const WalletIcon: React.FC<IconProps> = () => {
  const { theme } = useThemeContext();
  return (
    <svg
      width="160"
      height="160"
      viewBox="0 0 160 160"
      fill="none"
      xmlns="http://www.w3.org/2000/svg">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M83.6299 19.1522L30.7029 39.1498C25.2564 41.2106 21.6667 46.4089 21.6667 52.2734V82.74C21.6667 85.5014 19.4282 87.74 16.6667 87.74C13.9053 87.74 11.6667 85.5014 11.6667 82.74V52.2734C11.6667 42.2711 17.8104 33.3361 27.164 29.7969L80.1036 9.79454C82.7786 8.7865 85.6582 8.44263 88.4954 8.79246C91.3325 9.14228 94.0424 10.1753 96.3924 11.803C98.7424 13.4306 100.662 15.6042 101.987 18.1372C103.313 20.6701 104.003 23.4868 104 26.3454L99.0001 26.34H104V26.3454V51.6734C104 54.4348 101.762 56.6734 99.0001 56.6734C96.2387 56.6734 94.0001 54.4348 94.0001 51.6734L94.0001 26.3346C94.0014 25.0941 93.7017 23.8718 93.1267 22.7725C92.5516 21.6733 91.7185 20.7301 90.6986 20.0237C89.6788 19.3174 88.5028 18.8691 87.2716 18.7173C86.0409 18.5655 84.7904 18.7151 83.6299 19.1522Z"
        fill={theme.secondary}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M41.7334 56.6665C30.6948 56.6665 21.6667 65.6946 21.6667 76.7332V121.6C21.6667 132.638 30.6948 141.667 41.7334 141.667H118.267C129.305 141.667 138.333 132.638 138.333 121.6V118.667H130.667C121.27 118.667 112.149 111.795 111.287 101.645C110.748 95.8966 112.937 90.5268 116.729 86.7996C120.14 83.321 124.816 81.3332 129.867 81.3332H138.333V76.7332C138.333 65.6946 129.305 56.6665 118.267 56.6665H41.7334ZM11.6667 76.7332C11.6667 60.1717 25.172 46.6665 41.7334 46.6665H118.267C134.828 46.6665 148.333 60.1717 148.333 76.7332V86.3332C148.333 89.0946 146.095 91.3332 143.333 91.3332H129.867C127.473 91.3332 125.368 92.2613 123.849 93.8213C123.82 93.8516 123.79 93.8815 123.759 93.911C121.986 95.6425 120.995 98.1078 121.244 100.726L121.249 100.785C121.602 105.018 125.673 108.667 130.667 108.667H143.333C146.095 108.667 148.333 110.905 148.333 113.667V121.6C148.333 138.161 134.828 151.667 118.267 151.667H41.7334C25.172 151.667 11.6667 138.161 11.6667 121.6V76.7332Z"
        fill={theme.primary}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M129.86 91.3335C127.466 91.3335 125.361 92.2616 123.842 93.8216C123.813 93.8519 123.783 93.8818 123.753 93.9114C121.979 95.6429 120.988 98.1081 121.238 100.726L121.243 100.785C121.596 105.018 125.666 108.667 130.66 108.667H143.612C144.689 108.597 145.393 107.755 145.393 106.867V93.1335C145.393 92.2457 144.689 91.403 143.612 91.3335H129.86ZM116.722 86.8C120.133 83.3214 124.809 81.3335 129.86 81.3335H143.727C143.786 81.3335 143.846 81.3346 143.905 81.3367C150.259 81.5636 155.393 86.7053 155.393 93.1335V106.867C155.393 113.295 150.259 118.437 143.905 118.664C143.846 118.666 143.786 118.667 143.727 118.667H130.66C121.263 118.667 112.142 111.795 111.28 101.645C110.742 95.8968 112.93 90.5272 116.722 86.8Z"
        fill={theme.primary}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M41.6667 80C41.6667 77.2386 43.9053 75 46.6667 75H93.3334C96.0948 75 98.3334 77.2386 98.3334 80C98.3334 82.7614 96.0948 85 93.3334 85H46.6667C43.9053 85 41.6667 82.7614 41.6667 80Z"
        fill={theme.secondary}
      />
    </svg>
  );
};

export default WalletIcon;
